import React from 'react';
import { Field } from 'formik';
import styled from 'styled-components';

type Props = {
    fieldName: string;
    label: string;
    type?: string;
    maxLength?: number;
    placeholder?: string;
    disabled?: boolean;
    pattern?: string;
    inputMode?: 'text' | 'tel' | 'numeric';
};

const EditableInputField = ({ fieldName, label, type = 'text', maxLength, placeholder, disabled = false, pattern, inputMode }: Props) => {
    return (
        <DetailWrapper>
            <DetailName>{label}</DetailName>
            <Field name={fieldName}>
                {({ field, meta }: any) => (
                    <>
                        <StyledInput
                            {...field}
                            type={type}
                            maxLength={maxLength}
                            placeholder={placeholder}
                            disabled={disabled}
                            pattern={pattern}
                            inputMode={inputMode}
                            hasError={meta.touched && meta.error}
                            onInput={inputMode === 'numeric' || inputMode === 'tel' ? (e: React.FormEvent<HTMLInputElement>) => {
                                const input = e.currentTarget;
                                const value = input.value;
                                
                                if (inputMode === 'tel') {
                                    // Allow only numbers, +, -, (, ), and space for phone numbers
                                    input.value = value.replace(/[^\d+\-() ]/g, '');
                                } else if (inputMode === 'numeric') {
                                    // Allow only numbers for numeric input
                                    input.value = value.replace(/\D/g, '');
                                }
                                
                                // Update formik field value
                                if (input.value !== value) {
                                    field.onChange({
                                        target: {
                                            name: field.name,
                                            value: input.value
                                        }
                                    });
                                }
                            } : undefined}
                        />
                        {meta.touched && meta.error && <ErrorText>{meta.error}</ErrorText>}
                    </>
                )}
            </Field>
        </DetailWrapper>
    );
};

const DetailWrapper = styled.div``;

const DetailName = styled.div`
    color: #008ac9;
    margin-bottom: 4px;
`;

const StyledInput = styled.input<{ hasError?: boolean }>`
    width: 100%;
    padding: 8px 12px;
    border: 1px solid ${props => props.hasError ? '#ff4d4f' : '#d9d9d9'};
    border-radius: 4px;
    font-size: 14px;
    color: #394372;
    background-color: ${props => props.disabled ? '#f5f5f5' : '#ffffff'};
    
    &:focus {
        outline: none;
        border-color: #008ac9;
        box-shadow: 0 0 0 2px rgba(0, 138, 201, 0.1);
    }
    
    &:disabled {
        cursor: not-allowed;
        color: #999;
    }
`;

const ErrorText = styled.div`
    color: #ff4d4f;
    font-size: 12px;
    margin-top: 4px;
`;

export default EditableInputField;